export default __webpack_public_path__ + "assets/home3.b9fa00e1.png";